import * as angular from 'angular';

class UndiscountedTariffComponentCtrl implements ng.IController {
    public ngModelCtrl: ng.INgModelController;
    public model: boolean;
    public verificationByUser: boolean;

    public onChange(): void {
        this.ngModelCtrl.$setViewValue(this.model);
    }

    $onInit(): void {
        this.ngModelCtrl.$render = () => {
            this.model = this.ngModelCtrl.$modelValue;
            this.ngModelCtrl.$setViewValue(this.model);
        };
    }
}

angular.module('app').component('pkpUndiscountedTariff', {
    controller: UndiscountedTariffComponentCtrl,
    template: require('app/_directives/undiscounted-tariff.component.html'),
    bindings: {
        verificationByUser: '<'
    },
    require: {
        ngModelCtrl: 'ngModel'
    }
});
